// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Modal_wrapper__2DXx5","exitButton":"Modal_exitButton__18G_A"};